import Toast from "./toast";

export class AddToCart {
    constructor() {
        document.addEventListener('click', e => {
            if (!e.target.closest('.add_to_cart_button, .single_add_to_cart_button')) return;

            e.preventDefault();

            const closest_el = e.target.closest('.add_to_cart_button, .single_add_to_cart_button'),
                form = e.target.closest('form'),
                data = new FormData();

            let isValid = true;

            let variations = document.querySelectorAll('.variation select');
            variations.forEach(variation => {
                let inputs = document.querySelectorAll('input[name=' + variation.name + ']');
                inputs.forEach(input => {
                    let label = input.parentElement;

                    label.classList.remove('error');
                    if (document.querySelectorAll('input[name="' + variation.name + '"]:checked').length === 0) {
                        isValid = false;
                        label.classList.add('error');
                    }
                });
            });

            data.append('product_id', form.querySelector('[name="product_id"]').value);
            data.append('quantity', form.querySelector('[name="quantity"]').value);
            data.append('variation_id', form.querySelector('[name="variation_id"]').value);

            if (isValid) {
                this.add_to_cart(data, form, closest_el);
            } else {
                let toast = document.querySelector('.woocommerce-added');
                toast.querySelector('.toast__body').innerHTML = `<span class="title">${toast.dataset.msg}</span>`;

                new Toast('.toast');

                window.scrollBy({
                    top: document.querySelector('.woocommerce-added').getBoundingClientRect().top - 100,
                    behavior: 'smooth'
                });
            }
        });
    }

    add_to_cart(data, form, btn) {
        const mini_cart = document.querySelector('.cart-item'),
            cart_count = mini_cart && mini_cart.querySelector('.count'),
            cart_modal = document.querySelector('#mini-cart'),
            cart_modal_content = cart_modal && cart_modal.querySelector('.mini-cart-wrapper');

        const language = document.documentElement.lang.split('-')[0];

        btn.classList.add('loading');

        let preview_cart = document.querySelector('.added_to_cart');
        preview_cart && preview_cart.remove();
        const cart_counter = document.querySelector('.cart-link .count');
        fetch(`/wp-json/custom/add-to-cart`, {
            method: 'post',
            body: data
        })
            .then(res => res.json())
            .then(json => {
                btn.classList.remove('loading');

                // Insert data
                cart_count && (cart_count.textContent = `${json.count}`);

                if (cart_modal_content) {
                    cart_modal_content.innerHTML = json.layout;
                }


                // checkout_link.innerHTML = link_to_checkout;
                document.querySelector('.woocommerce-added').classList.add('success');
                document.querySelector('.woocommerce-added .toast__body').innerHTML = json.message;
                document.querySelector('.cart_number').innerHTML = json.count;

                new Toast('.toast');

                window.scrollBy({
                    top: document.querySelector('.woocommerce-added').getBoundingClientRect().top - 200,
                    behavior: 'smooth'
                });
            })
            .catch(err => console.error(err));
    }
}



// WEBPACK FOOTER //
// ./scripts/modules/cart.js